import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import PainPoints from "@/components/PainPoints";
import SolutionsSection from "@/components/SolutionsSection";
import DesiredOutcomes from "@/components/DesiredOutcomes";
import ServiceIntro from "@/components/ServiceIntro";
import Clients from "@/components/Clients";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll animation observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const animateElements = document.querySelectorAll('.animate-on-scroll');
    animateElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    // Handle hash navigation when coming from other pages
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        // Small delay to ensure page is fully loaded
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <Helmet>
        <title>Tagnetica - Expert Analytics & Tag Management Consulting</title>
        <meta name="description" content="Get accurate, actionable analytics data without the headaches. Expert Google Tag Manager, GA4, and Matomo consulting services." />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta name="bingbot" content="index, follow" />
        <meta property="og:title" content="Tagnetica - Expert Analytics & Tag Management Consulting" />
        <meta property="og:description" content="Get accurate, actionable analytics data without the headaches. Expert Google Tag Manager, GA4, and Matomo consulting services." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://tagimplementation.tagnetica.co.uk" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Tagnetica - Expert Analytics & Tag Management Consulting" />
        <meta name="twitter:description" content="Get accurate, actionable analytics data without the headaches. Expert Google Tag Manager, GA4, and Matomo consulting services." />
      </Helmet>
      
      <Header />
      
      <main className="pt-16">
        <Hero />
        
        <div id="challenges">
          <PainPoints />
          <SolutionsSection />
          <DesiredOutcomes />
          <ServiceIntro />
        </div>

        <div id="clients">
          <Clients />
        </div>

        <div id="contact">
          <ContactForm />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Index;
